import type { $Fetch } from 'ofetch';
import type { CalendarioEventoGateway, ListCalendarioParams } from '@/application/port/out/CalendarioEventoGateway';
import type { CalendarioEvento, UpsertCalendarioEventoCommand } from '@/domain/model/CalendarioEvento';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/calendario';

/** HTTP gateway do Calendário Acadêmico. Authority BE: `enrollment:calendario:read|manage`. */
export class HttpCalendarioEventoGateway implements CalendarioEventoGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListCalendarioParams): Promise<Page<CalendarioEvento>> {
    const res = await this.client<ApiResponse<Page<CalendarioEvento>>>(
      ROOT, { method: 'GET', params: { page: params.page, size: params.size } });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertCalendarioEventoCommand): Promise<CalendarioEvento> {
    const res = await this.client<ApiResponse<CalendarioEvento>>(ROOT, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertCalendarioEventoCommand): Promise<CalendarioEvento> {
    const res = await this.client<ApiResponse<CalendarioEvento>>(
      `${ROOT}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async remove(id: string): Promise<void> {
    // BE retorna ApiResponse<Void> — valida sucesso, ignora data.
    const res = await this.client<ApiResponse<unknown>>(
      `${ROOT}/${encodeURIComponent(id)}`, { method: 'DELETE' });
    assertApiSuccess(res);
  }
}
